// export const BASE_URL = "http://localhost:8000"
export const BASE_URL = "https://mernblogappbackend-1s0p.onrender.com"

